"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _v = _interopRequireDefault(require("uuid/v4"));

var _input = _interopRequireDefault(require("./input"));

var _reactSelect = _interopRequireDefault(require("react-select"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var Select =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Select, _React$Component);

  function Select(props) {
    var _this;

    _classCallCheck(this, Select);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Select).call(this, props));
    _this.state = {
      uuid: (0, _v.default)()
    };
    return _this;
  }

  _createClass(Select, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: this.wrapperClass()
      }, _react.default.createElement("label", {
        htmlFor: this.state.uuid,
        className: "control-label"
      }, this.props.label, this.renderRequired()), this.renderSelect(), this.renderHelp());
    }
  }, {
    key: "wrapperClass",
    value: function wrapperClass() {
      var str = 'form-group';

      if (_input.default.contexts[this.props.context]) {
        str += " has-".concat(_input.default.contexts[this.props.context]);
      }

      return str;
    }
  }, {
    key: "deconstructedProps",
    value: function deconstructedProps() {
      var ret = {};

      if (this.props.disabled) {
        ret.disabled = true;
      }

      if (this.props.multiple) {
        ret.multiple = true;
      }

      return ret;
    }
  }, {
    key: "formattedOptions",
    value: function formattedOptions() {
      var _this2 = this;

      if (this.props.options && this.props.options.length === 0) {
        return [];
      }

      return this.props.options.map(function (o) {
        var opt = {
          value: o,
          label: o
        };

        if (_typeof(o) === 'object' && _this2.props.valueKey && _this2.props.displayKey) {
          opt.value = o[_this2.props.valueKey];
          opt.label = o[_this2.props.displayKey];
        }

        return opt;
      });
    }
  }, {
    key: "optionList",
    value: function optionList() {
      var optionsList = [];

      if (this.props.options && this.props.options.length > 0) {
        optionsList = this.formattedOptions().map(function (o) {
          return _react.default.createElement("option", {
            key: o.value,
            value: o.value
          }, o.label);
        });
      }

      if (this.props.placeholder) {
        optionsList.splice(0, 0, _react.default.createElement("option", {
          hidden: true,
          key: "PlaceHolder",
          value: ""
        }, this.props.placeholder));
      }

      return optionsList;
    }
  }, {
    key: "renderHelp",
    value: function renderHelp() {
      if (this.props.help) {
        return _react.default.createElement("span", {
          className: "help-block"
        }, this.props.help);
      }

      return null;
    }
  }, {
    key: "renderSelect",
    value: function renderSelect() {
      var _this3 = this;

      if (this.props.searchable) {
        var values = this.formattedOptions();
        var value = values.find(function (v) {
          return v.value === _this3.props.value;
        });
        return _react.default.createElement(_reactSelect.default, _extends({}, this.props, {
          options: this.formattedOptions(),
          isMulti: this.props.multiple,
          id: this.state.uuid,
          value: value,
          className: "react-select-container",
          classNamePrefix: "react-select"
        }));
      }

      return _react.default.createElement("select", _extends({}, this.deconstructedProps(), {
        id: this.state.uuid,
        className: "form-control",
        onChange: this.props.onChange,
        value: this.props.value
      }), this.optionList());
    }
  }, {
    key: "renderRequired",
    value: function renderRequired() {
      if (this.props.required) {
        return _react.default.createElement("em", {
          className: "required-mark",
          "aria-hidden": "true",
          title: "Required"
        }, "*");
      }
    }
  }]);

  return Select;
}(_react.default.Component);

var _default = Select;
exports.default = _default;